import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as getters from './getters';
import shops from './modules/shops';
import game from './modules/game';
import managers from './modules/managers';
import achievements from './modules/achievements';
import upgrades from './modules/upgrades';
import tutorial from './modules/tutorial';
import VuexPersistence from 'vuex-persist';
import BigNumber from 'bignumber.js/bignumber';

Vue.use(Vuex);

const strict = process.env.NODE_ENV !== 'production',
    vuexPersist = new VuexPersistence({
        strictMode:   strict,
        restoreState: (name, storage) => {
            if (typeof storage[name] === 'undefined') {
                return {};
            }
            const loadedData = JSON.parse(storage[name]);
            if (typeof loadedData === 'undefined' || loadedData.game.doReset === true) {
                return {};
            }
            if (typeof loadedData.lifetimeEarnings === 'undefined') {
                loadedData.lifetimeEarnings = 0;
            }
            loadedData.game.balance = new BigNumber(loadedData.game.balance);
            loadedData.game.lifetimeEarnings = new BigNumber(loadedData.game.lifetimeEarnings);
            loadedData.game.sessionEarnings = new BigNumber(loadedData.game.sessionEarnings);
            return loadedData;
        },
        filter:       mutation => {
            return mutation.type === 'SAVE_GAME';
            // return !(mutation.type === 'UPDATE_PRODUCTION_PROGRESSES'
            //     || mutation.type === 'FINISH_PRODUCTION'
            //     || mutation.type === 'CLEANUP_QUEUE'
            //     || mutation.type.indexOf('SET_') === 0
            //     || mutation.type.indexOf('RECEIVE_') === 0
            //     || mutation.type.indexOf('i18n') === 0
            //     || mutation.type.indexOf('INITIALIZE') === 0
            // );
        }
    });

export default new Vuex.Store({
    strict:    strict,
    actions,
    getters,
    modules:   {
        shops,
        game,
        managers,
        achievements,
        upgrades,
        tutorial
    },
    mutations: {
        RESTORE_MUTATION: vuexPersist.RESTORE_MUTATION
    },
    plugins:   [vuexPersist.plugin]
});
